import styles from "./VoiceCapabilities.module.css";
import {
    Mic,
    Heart,
    Zap,
    Globe,
    Phone,
    Brain,
} from "lucide-react";

const features = [
    {
        icon: <Mic />,
        title: "Human-Like Voice",
        desc: "Powered by Vox, our voices are indistinguishable from humans with natural pauses, filler words, and breathing patterns.",
    },
    {
        icon: <Heart />,
        title: "Emotional Intelligence",
        desc: "Detect customer sentiment in real-time and respond with appropriate emotion empathy, urgency, warmth, or calm.",
    },
    {
        icon: <Zap />,
        title: "Sub-Second Latency",
        desc: "< 900ms response time ensures natural conversation flow. No awkward silences or robotic delays.",
    },
    {
        icon: <Globe />,
        title: "20+ Languages",
        desc: "Native fluency across Hindi, Tamil, Telugu, Bengali, and 16+ more languages with regional accent support.",
    },
    {
        icon: <Phone />,
        title: "Inbound & Outbound",
        desc: "Handle incoming support calls or run outbound campaigns for sales, collections, and reminders at any scale.",
    },
    {
        icon: <Brain />,
        title: "Context-Aware",
        desc: "Agents remember conversation history, customer preferences, and past interactions for personalized experiences.",
    },
];

const VoiceCapabilities = () => {
    return (
        <section className={styles.wrapper}>
            <h2 className={styles.title}>Voice Capabilities</h2>
            <p className={styles.subtitle}>
                Everything you need to deploy voice AI that customers love talking to.
            </p>

            <div className={styles.grid}>
                {features.map((item, index) => (
                    <div className={styles.card} key={index}>
                        <div className={styles.iconBox}>{item.icon}</div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default VoiceCapabilities;